import { BaseMemberActionError } from '../base-member-action-error';

export class MissingRequiredValueError extends BaseMemberActionError {
  constructor(actionClassInstance, value) {
    super(actionClassInstance, `Missing required value "${value}"`);
  }
}
